import { render } from "./HomePokemon.vue?vue&type=template&id=db130dba"
import script from "./HomePokemon.vue?vue&type=script&lang=js"
export * from "./HomePokemon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__